import L from 'leaflet'
// 定义一些公共的属性和方法
const configObj = {}
const map = {}
const manualLayerGroup = L.layerGroup([]) // 手动标注图层
const deviceLayerGroup = L.layerGroup([]) // 设备图层
const resourceLayerGroup = L.layerGroup([]) // 设备图层
const monitorLayerGroup = L.layerGroup([]) // 监控范围图层组
const shieldLayerGroup = L.layerGroup([]) // 屏蔽区域图层组
const routerLayerGroup = L.layerGroup([]) // 轨迹图层
const aisLayerGroup = L.layerGroup([])
const alarmLayerGroup = {} // 目标点报警图层
const linkGroup = {} // 地图联动图层
const aisRouterLayerGroup = L.layerGroup([])
const osmMark = ''
const geo = ''
const showManualLayer = true
const showMonitorLayer = true
const showAlarmLayer = true
const showDeviceLayer = true
const showResourceLayer = true
const showShieldLayer = true
const showAisLayer = false
const semiCircleObj = {}
const monitorColor = 'red'
const monitorOpacity = 0.8
const blindColor = 'gray'
const blindOpacity = 0.8
const markerObjDevice = {}
const labelObjDevice = {}
const targetDotMarker = {}
const aisMarker = {}
const markerObjResource = {}
const iconObjResource = {}
const currentUserId = ''
const mapZoom = 14
const mybounds = null
const tk = '27e1a4ea16a0b3070dab34c5ba4ca2e2'
const markerObjDot = {}
const lineObj = {}
const areaObj = {}
const angleObj = {}
const historyResourceId = '' // 某个资源点展示出来tooltip，双击下一个资源的时候，要将上一个tooltip关闭
const shieldAreaObj = {} // 屏蔽区域
const shieldAreaCircleMarker = {} // 屏蔽区域顶点小圆圈
const shieldAreaCircleMarkerSave = {} // 屏蔽区域顶点小圆圈
const nameReg = /^[\u4e00-\u9fa5A-Za-z0-9-_——]+$/
// 暴露出这些属性
export default {
  configObj,
  map,
  manualLayerGroup,
  deviceLayerGroup,
  resourceLayerGroup,
  monitorLayerGroup,
  shieldLayerGroup,
  routerLayerGroup,
  alarmLayerGroup,
  aisLayerGroup,
  linkGroup,
  aisRouterLayerGroup,
  osmMark,
  geo,
  showManualLayer,
  showMonitorLayer,
  showAlarmLayer,
  showDeviceLayer,
  showResourceLayer,
  showShieldLayer,
  showAisLayer,
  semiCircleObj,
  monitorColor,
  monitorOpacity,
  blindColor,
  blindOpacity,
  markerObjDevice,
  labelObjDevice,
  targetDotMarker,
  aisMarker,
  currentUserId,
  mapZoom,
  mybounds,
  tk,
  markerObjResource,
  iconObjResource,
  markerObjDot,
  lineObj,
  areaObj,
  angleObj,
  historyResourceId,
  shieldAreaObj,
  shieldAreaCircleMarker,
  shieldAreaCircleMarkerSave,
  nameReg
}
